import { render, staticRenderFns } from "./DraggableQuestion.vue?vue&type=template&id=86c50a20&"
import script from "./DraggableQuestion.vue?vue&type=script&lang=js&"
export * from "./DraggableQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DraggableQuestion.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports